import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter as Router } from 'react-router-dom';
import { CartProvider } from './contexts/CartContext';
import { AuthProvider } from './contexts/AuthContext';
import { HelmetProvider } from 'react-helmet-async';
import { Toaster } from 'react-hot-toast';
import App from './App';
import './index.css';

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <HelmetProvider>
      <AuthProvider>
        <CartProvider>
          <Router>
            <App />
            <Toaster 
              position="top-right"
              toastOptions={{
                duration: 3000,
                success: {
                  duration: 2000,
                },
                error: {
                  duration: 4000,
                },
              }}
            />
          </Router>
        </CartProvider>
      </AuthProvider>
    </HelmetProvider>
  </StrictMode>
);